"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/prefer-default-export, camelcase */
var rest_1 = __importDefault(require("../../rest"));
var labs_1 = require("../mock/labs");
var coreServiceUrl = process.env.CB_CORE_SERVICE_SERVER_URL;
var LabsAPIs = {
    getLabInfo: function (labUuid, token) {
        return rest_1.default.get({
            mockFunc: function () { return labs_1.mockLabInfo; },
            url: "".concat(coreServiceUrl, "/labs/info/").concat(labUuid),
            token: token,
        });
    },
    startLab: function (labUuid, token) {
        return rest_1.default.post({
            url: "".concat(coreServiceUrl, "/labs/start"),
            body: {
                uuid: labUuid,
            },
            token: token,
        });
    },
    deleteLab: function (labUuid, token) {
        return rest_1.default.delete({
            url: "".concat(coreServiceUrl, "/labs/").concat(labUuid),
            token: token,
        });
    },
    updateLab: function (labUuid, token, body) {
        return rest_1.default.put({
            url: "".concat(coreServiceUrl, "/labs/").concat(labUuid),
            body: body,
            token: token,
        });
    },
    createLab: function (token, body) {
        return rest_1.default.post({
            url: "".concat(coreServiceUrl, "/labs"),
            body: body,
            token: token,
        });
    },
    deleteVulnerabilityFixQuestion: function (questionUuid, token) {
        return rest_1.default.delete({
            url: "".concat(coreServiceUrl, "/labs/vulnerability-fix-question/").concat(questionUuid),
            token: token,
        });
    },
    updateVulnerabilityFixQuestion: function (questionUuid, token, body) {
        return rest_1.default.put({
            url: "".concat(coreServiceUrl, "/labs/vulnerability-fix-question/").concat(questionUuid),
            body: body,
            token: token,
        });
    },
    createVulnerabilityFixQuestion: function (token, body) {
        return rest_1.default.post({
            url: "".concat(coreServiceUrl, "/labs/vulnerability-fix-question"),
            body: body,
            token: token,
        });
    },
    submitLabQuestionUserRemediation: function (token, body) {
        return rest_1.default.post({
            url: "".concat(coreServiceUrl, "/labs/submit"),
            body: body,
            token: token,
        });
    },
};
exports.default = LabsAPIs;
